var exports = {
  "KE": "SelectionFormattingToolbar.module__toolbar___QzdoTV",
  "x6": "SelectionFormattingToolbar.module__button___QzdoTV",
  "rK": "SelectionFormattingToolbar.module__buttonActive___QzdoTV",
  "Kk": "SelectionFormattingToolbar.module__icon___QzdoTV",
};

module.exports = exports;
